import Abstract from "../../abstract-view/abstract.js";

import {
  createElement
} from "../../render/render.js";

import {
  DELIVERY_DATE_LIMIT_HOUR,
  DELIVERY_DATE_ITEMS_COUNT
} from "../const.js";

import {
  WEEK_DAYS_LEXICON,
  ANOTHER_DAY_LEXICON,
  SUBMIT_TEXT_LEXICON,
  SUCCESS_TEXT_LEXICON
} from "../lexicon.js";

const createDateInputTemplate = ({title, description, value}, index) => {
  const checkedLayout = (index === 0) ? ` checked` : ``;
  const descriptionLayout = (description) ?
    `<span class="form-radio-description">${description}</span>` :
    ``;

  return (
    `<li class="cart-order-item-list__item cart-order-item-list__item_width_third">
      <label class="form-label form-label_radio">
        <input class="form-radio visually-hidden" type="radio" name="date_shipping" value="${value}"${checkedLayout}>
        <span class="form-radio-title">${title}</span>
        ${descriptionLayout}
      </label>
    </li>`
  );
};

const createDateTemplate = () => {
  let currentDateObj = new Date();

  if (currentDateObj.getHours() >= DELIVERY_DATE_LIMIT_HOUR) {
    currentDateObj.setDate(currentDateObj.getDate() + 1);
  }

  const currentDate = currentDateObj.getDate();
  const currentDay = currentDateObj.getDay();

  const daysData = Array(DELIVERY_DATE_ITEMS_COUNT)
    .fill(``)
    .map((item, index) => {
      let weekDayNumber = currentDay + index - 1;

      if (weekDayNumber >= 7) {
        weekDayNumber = weekDayNumber - 7;
      }

      if (weekDayNumber < 0) {
        weekDayNumber = weekDayNumber + 7;
      }

      const dayName = WEEK_DAYS_LEXICON[weekDayNumber];
      const weekDayDate = new Date(currentDateObj.getTime());
      weekDayDate.setDate(currentDate + index);

      let month = weekDayDate.getMonth() + 1;

      if (+month < 10) {
        month = `0${month}`;
      }

      const humanizeDate = `${weekDayDate.getDate()}.${month}.${weekDayDate.getFullYear()}`;
      const serverDate = `${weekDayDate.getFullYear()}-${month}-${weekDayDate.getDate()} 12:00:00`;

      return {
        title: dayName,
        description: humanizeDate,
        value: serverDate
      };
    });

  daysData.push({
    title: ANOTHER_DAY_LEXICON,
    value: ``
  });

  const dateInputsLayout = daysData
    .slice()
    .map((data, index) => createDateInputTemplate(data, index))
    .join(`\n`);

  return (
    `<ul class="cart-order-item-list cart-order-item-list_no-margins cart-order-item-list_custom-width">
      ${dateInputsLayout}
    </ul>`
  );
};

const createAddressTemplate = () => {
  const dateLayout = createDateTemplate();

  return (
    `<li class="cart-order-item cart-order-item_address" style="display: none;">
      <h3 class="cart-order-item__heading">Адрес доставки</h3>
      <ul class="cart-order-item-list">
        <li class="cart-order-item-list__item">
          <div class="form-item-wrapper form-item-wrapper_cart">
            <label class="form-label" for="receiver">Имя получателя</label>
            <input id="receiver" class="form-input" name="receiver" type="text" placeholder="Как к вам обращаться?">
          </div>
        </li>
        <li class="cart-order-item-list__item">
          <label class="form-label" for="phone-shipping">Телефон<span class="form-label__required">*</span></label>
          <div class="form-item-wrapper form-item-wrapper_cart">
            <input id="phone-shipping" class="form-input" name="phone_shipping" type="tel" placeholder="+7 (">
          </div>
        </li>
        <li class="cart-order-item-list__item">
          <div class="form-item-wrapper form-item-wrapper_cart">
            <label class="form-label" for="address-shipping">Адрес получателя</label>
            <textarea id="address-shipping" class="form-input form-textarea" name="text_address" placeholder="Укажите адрес получателя"></textarea>
          </div>
        </li>
      </ul>
      <h3 class="cart-order-item__heading">Дата доставки</h3>
      ${dateLayout}
      <p class="cart-order-descriptor">Точная стоимость будет рассчитана и согласована с вами при подтверждении заказа.</p>
    </li>`
  );
};

const createMapTemplate = () => {
  return (
    `<li class="cart-order-item cart-order-item_map" style="display: none;">
      <h3 class="cart-order-item__heading cart-order-item__heading_no-label">Выберите адрес на карте</h3>
      <div class="cart-delivery-map"></div>
    </li>`
  );
};

export default class OrderForm extends Abstract {
  constructor(element) {
    super();

    this._element = element;
    this._paymentItemElement = null;
    this._addressItemElement = null;
    this._mapItemElement = null;
    this._mapContainerElement = null;
    this._addressShippingElement = null;
    this._submitButtonElement = null;

    this._defaultSubmitButtonText = null;
  }

  getPaymentItemElement() {
    if (!this._paymentItemElement) {
      this._paymentItemElement = this._element.querySelector(`.cart-order-item_payment`);
    }

    return this._paymentItemElement;
  }

  getAddressItemElement() {
    if (!this._addressItemElement) {
      this._addressItemElement = createElement(this._getAddressTemplate());
    }

    return this._addressItemElement;
  }

  removeAddressItemElement() {
    this._addressItemElement = null;
  }

  getMapItemElement() {
    if (!this._mapItemElement) {
      this._mapItemElement = createElement(this._getMapTemplate());
    }

    return this._mapItemElement;
  }

  removeMapItemElement() {
    this._mapItemElement = null;
  }

  getMapContainerElement() {
    if (!this._mapContainerElement) {
      this._mapContainerElement = this.getMapItemElement().querySelector(`.cart-delivery-map`);
    }

    return this._mapContainerElement;
  }

  getAddressShippingElement() {
    if (!this._addressShippingElement) {
      this._addressShippingElement = this._element.querySelector(`[name="text_address"]`);
    }

    return this._addressShippingElement;
  }

  setAddressShippingValue(value) {
    this.getAddressShippingElement().value = value;
  }

  getFormPropertyValue(property) {
    const formData = new FormData(this._element);
    return formData.get(property);
  }

  getRadioLabelsElements() {
    return this._element.querySelectorAll(`.form-label_radio`);
  }

  getSubmitButtonElement() {
    if (!this._submitButtonElement) {
      this._submitButtonElement = this._element.querySelector(`button[type="submit"]`);
    }

    return this._submitButtonElement;
  }

  setSubmitting() {
    const submitButton = this.getSubmitButtonElement();

    submitButton.disabled = true;
    this._defaultSubmitButtonText = submitButton.textContent;

    submitButton.textContent = SUBMIT_TEXT_LEXICON;
  }

  setSuccess() {
    const submitButton = this.getSubmitButtonElement();

    submitButton.disabled = false;

    submitButton.textContent = SUCCESS_TEXT_LEXICON;
  }

  reset() {
    const submitButton = this.getSubmitButtonElement();

    submitButton.disabled = false;
    submitButton.textContent = this._defaultSubmitButtonText;
  }

  _getAddressTemplate() {
    return createAddressTemplate();
  }

  _getMapTemplate() {
    return createMapTemplate();
  }
}
